import { render, staticRenderFns } from "./EditAccount.vue?vue&type=template&id=61c5ac78&"
import script from "./EditAccount.vue?vue&type=script&lang=ts&"
export * from "./EditAccount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports